import { useSearch } from "wouter-preact/use-location"
import { connect_list_url, parse_connect_tab_from_location } from "./connect_tab"

/** Resolve post-connect redirect, preserving the connections list tab from `?tab=`. */
export function use_connect_redirect_to(
  prop_redirect_to?: string,
  default_base_url: string = "/setup/connect"
): string {
  const search = useSearch()
  const base = prop_redirect_to ?? default_base_url
  const tab = parse_connect_tab_from_location(search, "")
  return connect_list_url(base, tab)
}
